export default __webpack_public_path__ + "static/media/6.da4abb01.jpg";